module.exports = __webpack_public_path__ + "static/media/logo.48208834.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/layout/ui/components/loader-processing/icons/logo.svg
// module id = 1137
// module chunks = 0